{
  "lobDropdownConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Automobile Liability",
        "value": "Automobile_Liability",
        "checked": false
      },
      {
        "index": "2",
        "name": "Worker's Compensation",
        "value": "Worker_Compensation",
        "checked": false
      },
      {
        "index": "3",
        "name": "Auto Physical Damage",
        "value": "Auto_Physical_Damage",
        "checked": false
      },
      {
        "index": "4",
        "name": "Products",
        "value": "Products",
        "checked": false
      },
      {
        "index": "5",
        "name": "General Liability",
        "value": "General_Liability",
        "checked": false
      }
    ]
  },
  "pricingPlanDropdownConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Deductible",
        "value": "Deductible",
        "checked": false
      },
      {
        "index": "2",
        "name": "Guaranteed Cost",
        "value": "Guaranteed_Cost",
        "checked": false
      }
    ]
  },
  "stateDropdownConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "Delaware",
        "value": "Delaware",
        "checked": false
      },
      {
        "index": "2",
        "name": "Washington",
        "value": "Washington",
        "checked": false
      },
      {
        "index": "3",
        "name": "Florida",
        "value": "Florida",
        "checked": false
      },
      {
        "index": "4",
        "name": "Alaska",
        "value": "Alaska",
        "checked": false
      },
      {
        "index": "5",
        "name": "California",
        "value": "California",
        "checked": false
      },
      {
        "index": "6",
        "name": "West Virginia",
        "value": "West_Virginia",
        "checked": false
      }
    ]
  },
  "policyPeriodDropdownConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "07/01/2004 - 07/01/2005",
        "value": "Date1",
        "checked": false
      },
      {
        "index": "2",
        "name": "07/01/2005 - 07/01/2006",
        "value": "Date2",
        "checked": false
      },
      {
        "index": "3",
        "name": "07/15/2005 - 07/15/2006",
        "value": "Date3",
        "checked": false
      },
      {
        "index": "4",
        "name": "07/01/2006 - 07/01/2007",
        "value": "Date4",
        "checked": false
      },
      {
        "index": "5",
        "name": "07/15/2006 - 07/15/2007",
        "value": "Date5",
        "checked": false
      },
      {
        "index": "6",
        "name": "07/01/2007 - 07/01/2008",
        "value": "Date6",
        "checked": false
      },
      {
        "index": "7",
        "name": "07/15/2007 - 07/15/2008",
        "value": "Date7",
        "checked": false
      },
      {
        "index": "8",
        "name": "07/01/2008 - 07/01/2009",
        "value": "Date8",
        "checked": false
      },
      {
        "index": "9",
        "name": "07/15/2008 - 07/15/2009",
        "value": "Date9",
        "checked": false
      },
      {
        "index": "10",
        "name": "07/01/2009 - 07/01/2010",
        "value": "Date10",
        "checked": false
      }
    ]
  },
  "policyNumberDropdownConfig": {
    "dataSource": [
      {
        "index": "1",
        "name": "20 UEN MS9081",
        "value": "pn_1",
        "checked": false
      },
      {
        "index": "2",
        "name": "20 UEN MS9082",
        "value": "pn_2",
        "checked": false
      },
      {
        "index": "3",
        "name": "20 UEN MS9083",
        "value": "pn_3",
        "checked": false
      },
      {
        "index": "4",
        "name": "20 WN MS9080",
        "value": "pn_4",
        "checked": false
      },
      {
        "index": "5",
        "name": "57 CES OA9327",
        "value": "pn_5",
        "checked": false
      }
    ]
  }
}

